import { render } from "./TheNavigation.vue?vue&type=template&id=3bd43151&scoped=true"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"

import "./TheNavigation.vue?vue&type=style&index=0&id=3bd43151&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd43151"]])

export default __exports__